'use strict';

var AbstractTableView = require('components/common/views/abstract_table_view');
var AppState = require('app_state');
var Misc = require('utils/misc');
var OOP = require('utils/oop');

module.exports = OOP.extend(
    AbstractTableView,
    {
        initialize: function (options) {
            this.listResult = options.listResult;
            this.listResultInitOptions = options;

            // if there is no function getTableConfiguration, throw an exception
            if (this.getTableConfiguration === undefined) {
                throw new Error('function getTableConfiguration must be defined');
            }

            var tableConfig = this.getTableConfiguration();
            tableConfig.listResult = tableConfig.listResult || this.listResult;
            tableConfig.itemsPerPage = tableConfig.itemsPerPage || options.itemsPerPage || AppState.getItemsPerPage();
            tableConfig.controller = tableConfig.controller || this.controller || options.controller;
            tableConfig.itemCount = Misc.coalesce(
                tableConfig.itemCount,
                this.itemCount,
                tableConfig.listResult && tableConfig.listResult.get !== undefined
                    ? tableConfig.listResult.get('count')
                    : undefined,
                tableConfig.listResult.count
            );
            tableConfig.currentSortCol = Misc.coalesce(tableConfig.currentSortCol, options.currentSortCol);
            tableConfig.currentSortDesc = Misc.coalesce(tableConfig.currentSortDesc, options.currentSortDesc);
            this.controller = this.controller || tableConfig.controller;

            // collection
            this.collection =
                this.collection || options.collection || tableConfig.listResult.get !== undefined
                    ? tableConfig.listResult.get('collection')
                    : undefined || tableConfig.listResult.collection;

            if (!tableConfig.getSortColumn) {
                tableConfig.getSortColumn = function (col) {
                    if (col.notSortable) return undefined;
                    if (col.sortCol) {
                        return col.sortCol;
                    }

                    var id = col.id;
                    if (id.startsWith('#_')) return id.substring(2);
                    return id;
                };
            }
            this.base.initialize(tableConfig);
        },
    },
    'AbstractListResultView'
);
